module.exports = __webpack_public_path__ + "img/bg-recruitment.edba8c79.png";